import React from 'react';

export const AbsentIcon = () => (
  <svg viewBox="2 2 44 45">
    <g>
      <g transform="translate(9.698485, 16.112698)">
        <path d="M14,2 C9.69801534,2 7.3102504,3.99335324 2.80740515,8.08462126 C7.3360016,12.7419371 9.72731024,15 14,15 C18.2726944,15 20.6640081,12.7419321 25.1925949,8.08462126 C20.689759,3.99335752 18.3019892,2 14,2 Z M14,0 C18.8458514,0 21.6917028,2.20146333 26.5375541,6.60439 C27.3550499,7.34718974 27.4156246,8.61205817 26.6728388,9.42956662 C26.657667,9.44626461 26.6422138,9.46270468 26.6264858,9.47887977 C21.7509905,14.4929599 18.8754953,17 14,17 C9.12450995,17 6.2490199,14.4929653 1.37352986,9.47889586 C0.603478632,8.68698666 0.621221769,7.4207679 1.41314541,6.65073153 C1.42932132,6.63500269 1.44576223,6.6195487 1.46246107,6.60437619 C6.30830738,2.20145873 9.15415369,0 14,0 Z" id="Rectangle-6" />
        <circle id="Oval" cx="14" cy="8" r="6" />
        <circle id="Oval" cx="11" cy="6" r="1" />
      </g>
      <g transform="translate(23.698485, 23.698485) rotate(-315.000000) translate(-23.698485, -23.698485) translate(2.698485, 2.698485)">
        <path d="M21,42 C9.40202025,42 4.54747351e-13,32.5979797 4.54747351e-13,21 C4.54747351e-13,9.40202025 9.40202025,0 21,0 C32.5979797,0 42,9.40202025 42,21 C42,32.5979797 32.5979797,42 21,42 Z M21,40 C31.4934102,40 40,31.4934102 40,21 C40,10.5065898 31.4934102,2 21,2 C10.5065898,2 2,10.5065898 2,21 C2,31.4934102 10.5065898,40 21,40 Z" id="Oval-9" />
        <polygon id="Line" points="20 1 22 1 22 41.5 20 41.5" />
      </g>
    </g>
  </svg>
);

export default AbsentIcon;
